import Footer from "@/components/landing/contact/Footer";
import Header from "@/components/landing/contact/Header";

export default function ContactAddress() {
  return (
    <div className="tw-min-h-screen tw-flex tw-flex-col tw-bg-black">
      <Header />

      <main className="tw-flex-1 tw-flex tw-justify-center tw-bg-black tw-text-white tw-py-20 tw-px-6 ">
        <div className="tw-max-w-xl tw-w-full tw-space-y-6 tw-text-left">
          <h1 className="tw-text-3xl tw-font-semibold tw-text-center">
            Contact Us
          </h1>

          <p className="tw-text-gray-300 tw-leading-relaxed">
            Hey there! <br />
            Questions on your protection plans – we are here to help! Please fill out the form or You can send us a WhatsApp message on: <br />
            <span className="tw-font-medium tw-text-white">
              +91 93240 95283
            </span>
          </p>

          <div className="tw-text-left tw-space-y-4 tw-pt-6">
            <div>
              <p className="tw-font-semibold">Address</p>
              <p className="tw-text-gray-300">
                EmbedMike India Private Limited
              </p>
            </div>

            <div>
              <p className="tw-font-semibold">Registered Office:</p>
              <p className="tw-text-gray-300">
                Unit 30, Virwani Industrial Estate, Goregaon East, Mumbai 400063
              </p>
            </div>

            <div>
              <p className="tw-font-semibold">Corporate Office:</p>
              <p className="tw-text-gray-300">
                313, Arun Chambers, Tardeo, Mumbai 400034
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
